import { useMutation } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

interface GetRoomTypeParams {
  propertyId: string;
  roomTypeId: string;
}

interface RoomTypeBedGroup {
  description?: string | null;
}

export interface RoomTypeResponse {
  bed_groups?: Array<RoomTypeBedGroup>;
}

export function useGetRoomType() {
  return useMutation({
    mutationFn: async ({ propertyId, roomTypeId }: GetRoomTypeParams) => {
      const response = await ReservationService.getRoomType(propertyId, roomTypeId);
      return response.result as RoomTypeResponse;
    },
  });
}
